import { render, staticRenderFns } from "./TitlePosition.vue?vue&type=template&id=7f3d224c&scoped=true&"
import script from "./TitlePosition.vue?vue&type=script&lang=js&"
export * from "./TitlePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3d224c",
  null
  
)

export default component.exports